import { Fade, Grid } from '@mui/material';
import { RoutalLoader, RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { useEffect } from 'react';

import More3Points from '../../../../assets/svg/More3Points';
import { GeoFence } from '../../../../domain/geoFence/GeoFence';
import { useRetrieveActiveProject } from '../../../../hooks/project/useRetrieveActiveProject';
import { useRetrieveProjectGeoFence } from '../../../../hooks/project/useRetrieveProjectGeoFence';
import { useRetrieveRightPanelInfo } from '../../../../hooks/right-panel/useRetrieveRightPanelInfo';
import { useSetPlanEditingGeoFence } from '../hooks/plan-details/useSetPlanEditingGeoFence';
import { PlanGeoFencesActionsMenu } from '../menus/PlanGeoFencesActionsMenu';
import { PlanGeoFenceBody } from './PlanGeoFenceBody';
import { PlanGeoFenceHeader } from './PlanGeoFenceHeader';

type PlanGeoFenceRightPanelProps = {
  showEdit?: boolean;
};

export const PlanGeoFenceRightPanel = ({ showEdit }: PlanGeoFenceRightPanelProps) => {
  const { run: setEditingGeoFence } = useSetPlanEditingGeoFence();
  const { data: activeProject } = useRetrieveActiveProject();
  const { detailId: geoFenceId, detailType, cleanRightPanelInfo } = useRetrieveRightPanelInfo();
  const {
    data: geoFence,
    isLoading,
    error: retrieveGeoFenceError,
  } = useRetrieveProjectGeoFence({ showErrorMessage: false, geoFenceId });

  const onClose = () => {
    cleanRightPanelInfo();
  };

  const isOpen = () => detailType === `geoFence` && !!geoFenceId;

  useEffect(() => {
    if (retrieveGeoFenceError) {
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retrieveGeoFenceError]);

  return (
    <div
      key={geoFenceId}
      style={{
        height: `calc(100vh - 46px)`, //38 px of height plus +4+4 of floating design
        zIndex: 450,
        backgroundColor: `white`,
        borderLeft: `1px solid ${RoutalPalette.neutral10}`,
        position: `relative`,
      }}
    >
      <Fade in={isOpen()} mountOnEnter>
        <Grid style={{ height: `100%` }}>
          <Grid
            container
            direction="column"
            style={{
              width: `400px`,
              padding: `0`,
              height: `100%`,
              backgroundColor: RoutalPalette.neutral00,
            }}
            wrap="nowrap"
          >
            {isLoading ? (
              <Grid
                container
                justifyContent="center"
                style={{ height: `100%`, overflow: `hidden` }}
                alignItems="center"
              >
                <RoutalLoader width={60} />
              </Grid>
            ) : (
              <>
                {/* --- PANEL HEADER */}
                {activeProject && geoFence && (
                  <>
                    <PlanGeoFenceHeader
                      geoFence={geoFence}
                      onClose={onClose}
                      options={
                        <PlanGeoFencesActionsMenu
                          geoFences={[geoFence]}
                          type="popover"
                          popoverProps={{
                            hideArrow: true,
                            content: <More3Points />,
                            style: {
                              color: RoutalPalette.secondary60,
                              padding: 0,
                              margin: 0,
                              border: `unset`,
                            },
                          }}
                          showEdit={showEdit}
                          showViewDetails={false}
                          onEditGeoFence={(geoFence: GeoFence) => {
                            setEditingGeoFence(geoFence);
                            cleanRightPanelInfo();
                          }}
                          onDisableGeoFence={() => {
                            cleanRightPanelInfo();
                          }}
                        />
                      }
                    />

                    <VSpacer small />

                    <Grid item container style={{ height: `calc(100% - 60px)`, overflowY: `auto` }}>
                      <div style={{ width: `100%`, height: `100%` }}>
                        <PlanGeoFenceBody geoFence={geoFence} />
                      </div>
                    </Grid>
                  </>
                )}
              </>
            )}
          </Grid>
        </Grid>
      </Fade>
    </div>
  );
};
